import {gql} from '@apollo/client';

export default gql`
  mutation measureFeed($input: MeasureFeedInput!) {
    authed {
      success
    }
    measureFeed(input: $input) {
      success
    }
  }
`;
